import React from 'react'
import styled from 'styled-components'
import Navigation from './nav'
import Header from './header'
import GiphyMarketingGlobalStyle from './giphy-marketing-landing-style'

const Container = styled.div`
    width: 100%;
    height: 100%;
    background: black;
    display: flex;
    flex-direction: column;
    align-items: center;
`

const MarketingLandingPage = () => (
    <>
        <GiphyMarketingGlobalStyle />
        <Container>
            <Navigation />
            <Header />
        </Container>
    </>
)

export default MarketingLandingPage
